import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { Table, TableCell, TableContainer, TableRow } from "@/components/Table";
import { ResultOf, graphql } from "@/config/graphql";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Dialog, IconButton, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";

const Fab = styled("button")`
  background: #2196f3;
  color: white;
  width: 24px;
  height: 24px;
  min-height: 24px;
  margin: auto;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  display: block;
  padding: 0;
  transition: 0.3s;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    background: #1976d2;
  }
`;
const SmallImage = styled("img")`
  width: auto;
  height: 50px;
  object-fit: cover;
`;
const Image = styled("img")`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const currentSupplyDetails = graphql(`
  query currentSupplyDetails($params: ReportParams!) {
    report(params: $params) {
      id
      supplyDetails {
        id
        resourceName
        resourceId
        initialQuantity
        finalQuantity
        incomeQuantity
        consumedQuantity
        comment
        photoUrl
      }
    }
  }
`);
interface SuppliesTableProps {
  onEdit?: (
    detail: NonNullable<
      ResultOf<typeof currentSupplyDetails>["report"]["supplyDetails"]
    >[number]
  ) => void;
}
export const SuppliesTable = (props: SuppliesTableProps) => {
  const params = useParams();
  const [previewImageDialog, setPreviewImageDialog] = useState(false);

  const { data } = useQuery(currentSupplyDetails, {
    variables: { params: { id: +(params.id || 0) } },
    fetchPolicy: "cache-only",
  });

  return (
    <TableContainer>
      <Table>
        <thead>
          <TableRow variant="mainHeader">
            <TableCell sx={{ minWidth: 40 }}></TableCell>

            <TableCell>Suministros</TableCell>
            <TableCell>Consumo [ton]</TableCell>
            <TableCell>Saldo inicial (+) [ton]</TableCell>
            <TableCell>Ingresos (+) [ton]</TableCell>
            <TableCell>Saldo final (-) [ton]</TableCell>
            <TableCell>Comentario</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </thead>
        <tbody>
          {data?.report?.supplyDetails?.map((detail, index) => {
            return (
              <TableRow key={index} onClick={() => props.onEdit?.(detail)}>
                <TableCell>
                  {props.onEdit && detail.id > 0 && (
                    <IconButton sx={{ color: "#333333" }}>
                      <CreateOutlinedIcon />
                    </IconButton>
                  )}
                  {props.onEdit && detail.id < 0 && (
                    <Fab>
                      <AddIcon />
                    </Fab>
                  )}
                </TableCell>
                <TableCell>{detail.resourceName}</TableCell>
                <TableCell computedValue textAlign="center">
                  {detail.id > 0 &&
                    (
                      Math.trunc((detail.consumedQuantity ?? 0) * 100) / 100
                    ).toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 &&
                    detail.initialQuantity?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 &&
                    detail.incomeQuantity?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 &&
                    detail.finalQuantity?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell>{detail.id > 0 && detail.comment}</TableCell>
                <TableCell>
                  {detail.id > 0 && detail.photoUrl && (
                    <>
                      <SmallImage
                        onClick={() => {
                          setPreviewImageDialog(true);
                        }}
                        src={detail.photoUrl}
                      />
                      <Dialog
                        open={previewImageDialog}
                        onClose={() => setPreviewImageDialog(false)}
                        fullWidth
                        PaperProps={{ sx: { maxWidth: 400 } }}
                      >
                        <Image src={detail.photoUrl} />
                      </Dialog>
                    </>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
    </TableContainer>
  );
};
